import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Drawer = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Drawer' {...props}>
    <path fill='none' stroke='#000000' strokeWidth='2' d='M1,14 L6,2 L18,2 L23,14 L21,22 L3,22 L1,14 Z M1,14 L23,14' />
  </StyledIcon>
);
